/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-rest-params */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LearningPlanInterface } from '../../+models';
import { ModelApiBase, PolpoApi } from '../shared';

@Injectable({ providedIn: 'root' })
export class LearningPlanApi extends ModelApiBase {
  constructor(api: PolpoApi) {
    super(api, 'LearningPlans');
  }

  find(params?: Record<string, any>): Observable<LearningPlanInterface[]> {
    const path = '';
    const httpParams = this._getHttpParams({ filter: params });
    return this.get<LearningPlanInterface[]>(path, httpParams);
  }

  getForBooks(eduContentBookIds: number[]): Observable<LearningPlanInterface[]> {
    const httpParams = this._getHttpParams({ eduContentBookIds });
    return this.get<LearningPlanInterface[]>('for-educontentbooks', httpParams);
  }
}
